<template>
  <ReceiveTable :opt-type="20"></ReceiveTable>
</template>

<script>
import ReceiveTable from '@/views/modules/erp/company/client/receive-table.vue'
export default {
  components: { ReceiveTable },
  data () {
    return {}
  },
  methods: {

  },
}
</script>

<style lang="scss" scoped>

</style>


